import React from 'react'
import {Card, CardContent} from '@/components/ui/card'
import Heading from '../typography/heading'
import BodyCopy from '../typography/body-copy'
import PropTypes from 'prop-types'

export const GoalBannerHeader = ({title, description}) => {
    return (
        <Card
            className="grid grid-cols-1 bg-white/90 rounded-md p-8 max-w-screen-lg m-auto border-gray-05"
            data-testid="goalBannerHeader-Card"
        >
            <CardContent
                className="flex flex-col h-full"
                data-testid="goalBannerHeader-CardContent"
            >
                <div className="px-3 py-4 text-center">
                    <Heading
                        tag="h1"
                        variant="h3"
                        content={title}
                        data-testid="goalBannerHeader-Heading"
                    />
                    <BodyCopy content={description} data-testid="goalBannerHeader-BodyCopy" />
                </div>
            </CardContent>
        </Card>
    )
}

GoalBannerHeader.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string
}

export default GoalBannerHeader
